/**
 * Strip Froala editor chrome from issuer-authored pitch deck / campaign HTML.
 *
 * The Froala WYSIWYG editor used in issuer_webapp persists its own
 * editor-mode attributes into the saved HTML — notably
 * `contenteditable="true"` on `<div class="fr-element fr-view">` wrappers.
 * When that HTML is rendered raw via `dangerouslySetInnerHTML` on a public
 * page, those attributes turn the body content into a live edit surface so
 * any visitor can type into it (see PD-34534b). Strip the attribute on the
 * way in so the discover side always sees inert markup.
 *
 * @param {string} html  Raw HTML string (issuer-authored, untrusted shape).
 * @returns {string} Same HTML with editor chrome removed and legacy links normalized.
 */
export const stripFroalaEditorChrome = (html) => {
  if (!html || typeof html !== 'string') return html;
  return html
    .replace(/\s+contenteditable(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+))?/gi, '')
    .replace(/\s+href=(["'])(https?:\/\/[^"']*)\1/gi, (match, quote, rawUrl) => {
      const cleanedUrl = rawUrl.replace(/\u00a0/g, '').trim();
      try {
        const parsed = new URL(cleanedUrl);
        const hostname = parsed.hostname.toLowerCase();
        const hasValidHostname = hostname === 'localhost' || hostname.includes('.');
        if (!hasValidHostname) return '';

        if (hostname === 'startengine.com' || hostname === 'www.startengine.com') {
          parsed.protocol = 'https:';
          parsed.hostname = 'www.startengine.com';
          return ` href=${quote}${parsed.toString()}${quote}`;
        }

        return ` href=${quote}${cleanedUrl}${quote}`;
      } catch {
        return '';
      }
    })
    .replace(
      /\b(src|data-src)=(["'])http:\/\/gen\.sendtric\.com\//gi,
      '$1=$2https://gen.sendtric.com/',
    );
};

export default stripFroalaEditorChrome;
